import { useTheme } from '@mui/material';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from '@teamworksdev/icons';

export const CollapseSlotIcon = ({
  onClick,
  onKeyDown,
  isCollapsed,
  name,
}: {
  onClick: (e: React.MouseEvent) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  isCollapsed: boolean;
  name: string;
}) => {
  const {
    palette: { greyscaleLight },
  } = useTheme();
  const iconColor = greyscaleLight[400];
  const IconPath = isCollapsed ? MdKeyboardArrowDown : MdKeyboardArrowUp;
  return (
    <IconPath
      size={18}
      color={iconColor}
      className="cursor-pointer focus:outline-2 focus:outline-offset-1 focus:outline-blue-500"
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={'button'}
      tabIndex={0}
      aria-expanded={!isCollapsed}
      aria-label={name}
    />
  );
};
